import { createApp } from 'vue'
import App from './App.vue'
import mdiVue from 'mdi-vue/v3'
import '@mdi/font/css/materialdesignicons.css'
import * as mdijs from '@mdi/js'
import router from './router/router' // Importieren des Routers
import { vuetify } from './plugin/vuetify'
const app = createApp(App)

app.use(mdiVue, { icons: mdijs })
app.use(router)   // ← Router separat registrieren
app.use(vuetify)

app.mount('#app')



